import createAxiosInstance from './Axios';

export const callGetGiftCardBalance = (
  giftCardNumber,
  reCaptchaToken,
  baseURL,
) => {
  const axiosInstance = createAxiosInstance(baseURL);
  return axiosInstance({
    url: `/form/giftCardBalance/${giftCardNumber}`,
    method: 'get',
    headers: {
      reCaptchaToken: reCaptchaToken,
    },
  });
};
